/**
 * @module DiagnosisArticle
 */

import Component from '../base/Component';
import './styles.css';
import '../../scripts/picture';

import '../../images/sprite/plus_bordered.svg';

/**
 * Превью статьи в диагностике
 */
export default class DiagnosisArticle extends Component {
    static className = 'diagnosis-article';

    initElements() {
        this.elements = {};
    }

    init(options) {
        super.init(options);
    }
}
